var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"افزودن دانش آموز جدید"}},[_c('avatar-uploader',{attrs:{"context":"student","user-id":0},on:{"change":_vm.avatarChanged}}),_c('form-student',{on:{"save":_vm.saveStudent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }